import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  // AiFillGithub,
  AiOutlineTwitter,
  // AiFillInstagram,
  // AiFillTelegram,
} from "react-icons/ai";
import { FaTelegramPlane } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I fell in love with crypto, and I’ve never looked back. 🚀
              <br />
              <br />I live and breathe the blockchain space, navigating the wild
              world of Web3 as:
              <br />
              <i>
                <b className="purple">
                  A DeGen exploring high-risk, high-reward opportunities
                </b>
              </i>
              <br />
              <br />
              <i>
                <b className="purple">
                  A Moderator keeping communities engaged and secure
                </b>
              </i>
              <br />
              <br />
              <i>
                <b className="purple">
                  A Caller spotting alpha and bringing top-tier plays
                </b>
              </i>
              <br />
              <br />
              <i>
                <b className="purple">
                  An Influencer shaping narratives and trends in crypto
                </b>
              </i>
              <br />
              <br />
              <i>
                <b className="purple">
                  A Developer building decentralized solutions
                </b>
              </i>
              <br />
              <br />
              <i>
                <b className="purple">
                  A Smart Contract Developer crafting secure, efficient
                  protocols
                </b>
              </i>
              <br />
              <br />
              <i>
                <b className="purple">
                  A Team & Community Advisor helping projects scale and succeed
                </b>
              </i>
              <br />
              <br />
              <i>
                <b className="purple">
                  A Community Manager fostering growth and engagement
                </b>
              </i>
              <br />
              <br />
              From managing communities to deploying smart contracts, I bring a
              mix of technical expertise and deep market insights to every
              project I touch.
              <i>
                <b className="purple">
                  Whether it's advising teams, leading discussions, or
                  developing on-chain solutions, I thrive at the intersection of
                  innovation and strategy in Web3.
                </b>
              </i>
              <br />
              <br />
              <i>
                <b className=""> Let’s build the future of crypto. 🔥</b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              {/* <li className="social-icons">
                <a
                  href="https://github.com/soumyajit4419"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li> */}
              <li className="social-icons">
                <a
                  href="https://x.com/Bami_crypto"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              {/* <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/soumyajit4419/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li> */}
              <li className="social-icons">
                <a
                  href="https://t.co/oVSID4WXT1"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaTelegramPlane />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
